/**
 * Handle Scroll Spy Nav 
 */

window.addEventListener('load', handleScroll);
window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', handleScroll);
const scrollSpyMainNav = document.querySelectorAll<HTMLElement>('.js-scroll-spy-main-nav');
const scrollSpySubNav = document.querySelectorAll<HTMLElement>('.js-scroll-spy-sub-nav');
const navLinks = document.querySelectorAll('.js-scroll-spy-nav a');

function handleScroll() {
    if (scrollSpyMainNav && scrollSpyMainNav[0]) {
        const windowScroll = window.scrollY;
        const scrollSpyMainNavHeight = scrollSpyMainNav[0].offsetHeight;
        // Focus One hides the main nav and floats the sub nav instead. There a tapped section stops
        // scroll-mt-24 (96px) below the top, under the floating sub nav, so the threshold has to reach
        // past that stopping point or the previous section stays highlighted.
        const stickyNavThreshold = scrollSpyMainNavHeight || (scrollSpySubNav[0] ? scrollSpySubNav[0].offsetHeight + 48 : 0);
        const scrollSpySubNavOffset = scrollSpySubNav[0].getBoundingClientRect().top + window.scrollY;
        
        if (windowScroll >= scrollSpySubNavOffset) {
            scrollSpyMainNav[0].classList.add('is-active');
        } else {
            scrollSpyMainNav[0].classList.remove('is-active');
        }
        
        navLinks?.forEach(function (navLink) {
            const section = document.querySelector<HTMLElement>(navLink.getAttribute('href') ?? '');

            if (section) {
                const sectionOffset = section.getBoundingClientRect().top + window.scrollY;
                const sectionHeight = section.offsetHeight;
                const sectionBottom = sectionHeight + sectionOffset;

                if (windowScroll - 12 < sectionBottom - stickyNavThreshold && windowScroll + 20 >= sectionOffset - stickyNavThreshold) {
                    const item = navLink.parentElement;
                    if (item && !item.classList.contains('is-active')) {
                        item.classList.add('is-active');
                        // A sub nav wider than a narrow phone scrolls sideways; keep the active tab visible.
                        const list = item.parentElement;
                        if (list && list.scrollWidth > list.clientWidth) {
                            list.scrollTo({ left: item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
                        }
                    }
                } else {
                    navLink.parentElement?.classList.remove('is-active');
                }
            }
        })
    }
}

//addEventListener('click', function (event) {
//    let el = event.target as HTMLElement;

//	if (el.tagName === 'A' && el.classList.contains('js-scroll-spy-nav')) {
//		event.preventDefault();

//		var topOffset = anchorContent.getBoundingClientRect().top + window.scrollY;

//		$('html, body').animate({ scrollTop: topOffset - 70 }, 500);
//	}
//})
